import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

import { computed, getCurrentInstance } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'WillBeSoon' },
  __name: 'WillBeSoon',
  props: {
    dontShowName: { type: Boolean }
  },
  setup(__props: any) {


const props = __props;
const instance = getCurrentInstance();

// eslint-disable-next-line no-underscore-dangle
const parent = computed(() => instance?.parent?.type.name);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h5", null, "Модуль находится в разработке", -1)
  ])))
}
}

})